module.exports = __webpack_public_path__ + "bfed110108888fbc2006cd4f98945855.svg";